import React, { Suspense } from "react";
import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";
import { IconCMS } from "@wwg/icons";
import { Auth } from "shared/@auth";
import LoadingPage from "shared/LoadingPage";
import Card from "shared/Card";

import styles from "./CMS.module.css";
import Landing from "./Landing";
import ContentEdit from "./ContentEdit";
import { ReactComponent as CMS_App_Icon } from "./icons/CMS_App_Icon.svg";

export function CMS() {
  const { path } = useRouteMatch();
  const { hasPermission } = Auth.useContainer();

  return (
    <Card className={styles.card}>
      <header className={styles.cmsHeader}>
        <div>
          <CMS_App_Icon />
          <h3 className={styles.title}>Content Management System</h3>
        </div>
      </header>

      <Suspense fallback={<LoadingPage />}>
        <Switch>
          {hasPermission("marketing.cms.write") && (
            <Route path={`${path}/edit/:id`}>
              <ContentEdit />
            </Route>
          )}

          {hasPermission("marketing.cms.write") && (
            <Route path={`${path}/add`}>
              <ContentEdit />
            </Route>
          )}

          <Route path={`${path}`}>
            <Landing />
          </Route>

          <Route path="*">
            <Redirect to={`${path}`} />
          </Route>
        </Switch>
      </Suspense>
    </Card>
  );
}
